<template>
    <div class="table-responsive mb-4">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Product Name</th>
                    <th>Batch</th>
                    <th>Mnf. Date</th>
                    <th>Exp. Date</th>
                    <th>Sale Rate</th>
                    <th>Rate</th>
                    <th>Qty</th>
                    <th>Discount</th>
                    <th>VAT</th>
                    <th>Total</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody v-if="itemDetails">
                <tr v-for="(item, index) in itemDetails">
                    <td>{{ item.product_name }}</td>
                    <td>{{ item.batch_number }}</td>
                    <td>{{ item.mfn_date }}</td>
                    <td>{{ item.exp_date }}</td>
                    <td>{{ item.selling_rate }}</td>
                    <td>{{ item.rate }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.discount_percent ? `${item.discount_percent}%` : '' }}</td>
                    <td>{{ item.vat_amount ? `${item.vat_amount}` : '' }}</td>
                    <td>{{ item.g_total }}</td>
                    <td>
                        <button
                            class="btn btn-sm btn-primary px-1 me-1"
                            @click="() => handleEditItem(item, index)"
                        >
                            <i class="fa fa-pencil-alt"></i>
                        </button>
                        <button
                            class="btn btn-sm btn-danger px-1"
                            @click="() => $emit('removeBill', index)"
                        >
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
    const props = defineProps({
        itemDetails: {
            type: Array,
            default: []
        },
        formRef: {
            type: Object,
        }
    })

    const handleEditItem = (item, index) => {
        props.formRef.setData(item)
        props.formRef.updateIndex = index;
    }

    
</script>